import { ERROR } from '@/helpers/constants';
import useToastContext from '@/hooks/useToastContext';
import campaignServices from '@/services/campaignServices';
import { AffectedPart } from '@/types/AffectedHardware';

export const usePdrsUnmark = (campaignId: string) => {
  const { addToast } = useToastContext();

  const unmarkPdrsIds = async (tableData: unknown[], rowsIdx: number[], onError: () => void): Promise<boolean> => {
    const partNumbersToUnmark = tableData?.filter((tableRow, idx) => rowsIdx.includes(idx))?.map((row) => (row as AffectedPart).numberOld) || [];

    if (!partNumbersToUnmark?.length) return false;

    try {
      await campaignServices.unmarkAssignments(campaignId, partNumbersToUnmark);
    } catch (error) {
      addToast((error as Error).message, ERROR);
      onError();
      throw new Error((error as Error).message);
    }

    return true;
  };

  return { unmarkPdrsIds };
};
